export const getUrlPath = (url, tableId) => tableId ? `${url}?tableId=${tableId}` : url;

export const getSiteUrls = (tableId) => ({
  homeUrl: getUrlPath('/', tableId),
  menuUrl: getUrlPath('/menu', tableId),
  bookingUrl: getUrlPath('/booking', tableId),
  contactUsUrl: getUrlPath('/#contactus', tableId),
  contactUrl: getUrlPath('/contact', tableId),
  galleryUrl: getUrlPath('/gallery', tableId),
  reviewsUrl: getUrlPath('/reviews', tableId),
  termsUrl: getUrlPath('/terms', tableId)
});



// WEBPACK FOOTER //
// ./helpers/url.helper.js